//analytics
import { IMPRESSION_ACTIONS, CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const clickSwiggyMoneyInfoCta = (screenName: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({ category: screenName, action: CLICK_ACTIONS.CLICK_SWIGGY_MONEY_INFO_CTA });
};

export const impressionSwiggyMoneyInfoCta = (
    screenName: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: screenName,
        action: IMPRESSION_ACTIONS.IMPRESSION_SWIGGY_MONEY_INFO_CTA,
    });
};

export const impressionSwiggyMoneyInfoHalfCard = (
    screenName: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({ category: screenName, action: IMPRESSION_ACTIONS.IMPRESSION_SWIGGY_MONEY_INFO_HALF_CARD });
};

export const closeSwiggyMoneyInfoHalfCard = (
    screenName: string,
    context: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({ category: screenName, action: CLICK_ACTIONS.CLICK_SWIGGY_MONEY_INFO_HALF_CARD_CLOSE, context });
};
